export default __webpack_public_path__ + "static/media/favorite.7690fed1.svg";